import { ApiCustomFieldDefinitionsListTargetModelEnum, CustomFieldDefinition } from '@api';
import { depaginate, useApi } from '@data-access';
import { useCallback, useEffect, useState } from 'react';

export const useCustomFieldDefinitions = (targetModel: ApiCustomFieldDefinitionsListTargetModelEnum) => {
  const { api } = useApi();
  const [customFieldDefinitions, setCustomFieldDefinitions] = useState<CustomFieldDefinition[]>([]);

  const fetchCustomFieldDefinitions = useCallback(async () => {
    const fetchedDefinitions = await depaginate(page =>
      api.apiCustomFieldDefinitionsList({
        page,
        targetModel,
      }),
    );

    setCustomFieldDefinitions(fetchedDefinitions.sort((left, right) => left.order - right.order));
  }, [api, targetModel]);

  useEffect(() => {
    fetchCustomFieldDefinitions();
  }, [fetchCustomFieldDefinitions]);

  return { customFieldDefinitions, fetchCustomFieldDefinitions };
};
